import { defineStore } from 'pinia'
import { debounce } from 'lodash-es'

export const useSettingsStore = defineStore('settings', {
  state: () => ({
    theme: 'light',
    language: 'ru',
    notifications: true,
    defaultSpace: 0,
    defaultProject: 0
  }),

  actions: {
    // Загрузка из localStorage
    loadSettings() {
      const saved = localStorage.getItem('appSettings')
      if (saved) {
        this.$patch(JSON.parse(saved));
      }
    },

    // Инициализация дебаунс-сохранения
    initAutoSave() {
      this.$subscribe(
        debounce((mutation, state) => {
          localStorage.setItem('appSettings', JSON.stringify(state))
        }, 500) // Задержка 500мс
      )
    }
  }
})